import { Controller } from '@hotwired/stimulus'
import * as WebAuthnJSON from '@github/webauthn-json'
import Toast from '/libs/toast'

export default class extends Controller {
  static values  = { callbackUrl: String }
  static targets = [ 'username' ]

  prepare(event) {
    const formSubmission = event.detail.formSubmission
    const username = this.usernameTarget.value

    if (!username) {
      formSubmission.stop()
      this.usernameTarget.focus()
      new Toast("Nom d'utilisateur manquant !", 'alert').show()
      return
    }

    formSubmission.body.append('username', username)
  }

  create(event) {
    if (!event.detail.success) {
      console.log(event.detail.error?.message)
      return
    }

    event.detail.fetchResponse.response.json().then(publicKey => {
      WebAuthnJSON.get({ 'publicKey': publicKey })
        .then(credential => this.#callback(credential))
        .catch(error => console.log(error))
    })
  }

  #callback(credential) {
    fetch(this.callbackUrlValue, {
      method: 'PUT',
      headers: {
        'X-CSRF-Token': document.querySelector("[name='csrf-token']").content,
        'Content-Type': 'application/json',
        'Accept': 'text/vnd.turbo-stream.html',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ credential: credential })
    }).then(response => response.text())
      .then((data) => {
        Turbo.renderStreamMessage(data)
      })
  }
}